import React, { useState, useEffect } from "react";
import {
  Grid,
  Button,
  DialogContent,
  Dialog,
  useMediaQuery,
  useTheme,
  TextField,
  TextareaAutosize
} from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete';
import PageHeader from "../../Components/PageHeader";
import LeftControl from "../../Components/LeftControl";

/** Local imports & Statics */
import { Imports } from '../../Imports';

/** Local dependencies & Libraries */
import Services from '../../Services';
import { seriliazeParams } from "../../helpers/seriliazeParams";
import { broadcastCol } from "../../Components/TableComponents/constants";
import DynamicTable from "../../Components/TableComponents/DynamicTable";
import moment from "moment-timezone";
import { ValidateDate } from "../../helpers/textValidation";
import { Form, Input, Modal, Select, Spin } from "antd";
import TextArea from "antd/lib/input/TextArea";
import { utility } from "../../helpers/loader";
import { LoadingOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { setPageLoader } from "../../redux/features/utils.slice";
import PageLayout from "../../Components/LayoutComponents/PageLayout";
import { DeleteForeverRounded } from "@material-ui/icons";


let {
  role
} = Imports;

const {
  broadcast,
  Storage,
  BroadcastClient,
  users,
  employee
} = Services;

/** Pre-req configuration */
// const roles = Object.values(role);

if (!localStorage.getItem('broadcasts'))
  localStorage.broadcasts = '[]';




const BroadcastMessages = () => {

  const [form] = Form.useForm()
  const [roles, setRoles] = useState([]);
  const [locations, setLocations] = useState([])
  const [open, setOpen] = useState(false);
  const [useBroadcasts, setBroadcasts] = useState([]);
  let { broadcastModal } = useSelector(state => state?.utils?.pageLoader)
  const [isAllowClear, setisAllowClear] = useState(false)

  const fetchLocation = async () => {
    let siteList = await employee.get_site_listing();
    if (siteList.httpStatus == 200) setLocations([{ id: "all", title: "All" }, ...siteList?.data])
  }
  const retreiveBroadcasts = async (offset = 0, limit = 10) => {
    let params = '?'.concat(seriliazeParams({ offset, limit }))
    try {
      const response = await broadcast.getAllSend({ params });
      setBroadcasts(response?.data);

    } catch (exc) {

    }
  }

  useEffect(() => {
    (async () => {
      try {
        const response = await users.allSubDepartmentsList();
        const { data } = response;
        setRoles([{ id: "all", title: "All" }, ...data]);
      } catch (exc) {

      }
    })();

    fetchLocation();
    retreiveBroadcasts();

  }, [])


  const sendBroadcasst = async (values) => {
    try {
      const { id } = JSON.parse(localStorage.user_profile);

      const broadcastMessageObject = {
        ...values,
        employee_id: id,
      }

      if (broadcastMessageObject?.TGSLocationId === "all") delete broadcastMessageObject?.TGSLocationId
      if (broadcastMessageObject?.subDepartmentId === "all") delete broadcastMessageObject?.subDepartmentId
      utility?.dispatch(setPageLoader({ pageName: "broadcastModal", flag: true }))
      const response = await broadcast.sendBroadcast(broadcastMessageObject);

      if (response?.httpStatus === 200) {
        retreiveBroadcasts();
        setOpen(false)
        utility?.dispatch(setPageLoader({ pageName: "broadcastModal", flag: false }))

      }
    } catch (exc) {
      utility?.dispatch(setPageLoader({ pageName: "broadcastModal", flag: false }))
    }
    utility?.dispatch(setPageLoader({ pageName: "broadcastModal", flag: false }))

  }



  const broadcastData = {
    header: broadcastCol,
    rows: useBroadcasts.map(row => [
      { value: row?.subDeptName ? row?.subDeptName?.replace(/;/g, ", ") : row?.SubDepartment?.name || "N/A", style: { width: "400px" } },
      { value: row?.locName ? row?.locName?.replace(/;/g, ", ") : row?.TGSLocation?.name || "N/A", style: { width: "600px" } },
      { value: ValidateDate(row?.createdAt), style: { width: "100px" } },
      { value: row?.subject, style: { width: "200px", lineBreak: "anywhere" } },
      { value: row?.message, style: { width: "200px", lineBreak: "anywhere" } }
    ])
  }


  let InputContainer = ({ label, children }) => {
    return <div className="input_container">
      <span className="label">{label}</span>
      {children}
    </div>
  }

  const handleSelectChange = (value) => {
    if (value.includes('all')) {
      // If 'All' is selected, set all values except 'all'
      const allValues = locations.map(x => x.id);
      form.setFieldsValue({ TGSLocationId: allValues.filter(val => val !== 'all') });
    } else {
      // Handle other cases (deselecting 'All' or selecting other options)
      form.setFieldsValue({ TGSLocationId: value });
    }
  };

  const handleSelectChangeSubdepartment = (value) => {
    if (value.includes('all')) {
      // If 'All' is selected, set all values except 'all'
      const allValues = roles.map(x => x.id);
      form.setFieldsValue({ subDepartmentId: allValues.filter(val => val !== 'all') });
    } else {
      // Handle other cases (deselecting 'All' or selecting other options)
      form.setFieldsValue({ subDepartmentId: value });
    }
  };

  return (
    <PageLayout>
      <Grid className="PagesFrame">
        <PageHeader />
        <Grid id="PageTitle">Broadcast Messages</Grid>
        <Grid xs={12} className="ContentPage">
          <Grid xs={12}>
            <Button onClick={() => {
              setOpen(true)
              form?.resetFields()
            }} className="LinkButton">
              Send Broadcast Message
            </Button>
            <Grid
              xs={12}
              container
              justify="space-between"
              className="LiqTables SafetyTable"
            >
              <DynamicTable tableData={broadcastData} pageFor="broadcastMessage" />
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* Modal */}
      <Modal
        open={open}
        onCancel={() => {
          setOpen(false)
          form.resetFields()
        }}
        footer={false}
        title={<strong>Send Broadcast Message</strong>}
      >
        <Spin
          spinning={broadcastModal || false}
          indicator={<LoadingOutlined
            style={{
              fontSize: 24,
            }}
            spin
          />}>
          <Form
            form={form}
            onFinish={(values) => sendBroadcasst(values)}
            onFinishFailed={err => console.log(err)}
          >
            <div className="form_broadcast_message">
              <InputContainer label="Location">
                <Form.Item
                  style={{ marginBottom: 0 }}
                  name={"TGSLocationId"}
                  rules={[{
                    required: true,
                    message: "Kindly select any value"
                  }]}
                >
                  <Select
                    mode="multiple"
                    showSearch
                    allowClear
                    style={{
                      maxHeight: "100px", overflowY: "auto"
                    }}
                    filterOption={(inputValue, option) => option.label ? option.label.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1 : null}
                    options={locations?.map(x => { return { value: x?.id, label: x?.title } })}
                    onChange={handleSelectChange}

                  />
                </Form.Item >
              </InputContainer>
              <InputContainer label="Sub Department">
                <Form.Item
                  style={{ marginBottom: 0 }}
                  name={"subDepartmentId"}
                  rules={[{
                    required: true,
                    message: "Kindly select any value"
                  }]}>
                  <Select
                    mode="multiple"
                    showSearch
                    allowClear
                    style={{
                      maxHeight: "100px", overflowY: "auto"
                    }}
                    filterOption={(inputValue, option) => option.label ? option.label.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1 : null}
                    options={roles?.map(x => { return { value: x?.id, label: x?.title } })}
                    onChange={handleSelectChangeSubdepartment}
                  />
                </Form.Item>
              </InputContainer>
              <InputContainer label="Subject">
                <Form.Item
                  name="subject"
                  style={{ marginBottom: 0 }}
                  rules={[{ required: true, message: "Kindly fill this field" }]}
                >
                  <Input maxLength={255} placeholder="Type here" />
                </Form.Item>
              </InputContainer>
              <InputContainer label="Message">
                <Form.Item
                  style={{ marginBottom: 0 }}

                  name="message"
                  rules={[{ required: true, message: "Kindly fill this field" }]}
                >
                  <TextArea maxLength={255} placeholder="Dear recipient, Please note that progress made on last week's event......" rows={4} />
                </Form.Item>
              </InputContainer>
              <div className="btn_container">
                <Button className="LinkButton" type="submit">Send Message</Button>
              </div>
            </div>
          </Form>
        </Spin>
      </Modal>


    </PageLayout >
  );
}

export default BroadcastMessages;

